import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'home',
    component: () => import('./view/home.vue'),
    meta: {
      title: 'MA开辟集团数智化发展新路径',
      keepAlive: true
    }
  },
  {
    name: 'index',
    component: () => import('./view/index.vue'),
    meta: {
      title: '首页',
      keepAlive: true
    }
  },
  {
    name: 'nqyindex',
    component: () => import('./view/nqy/index.vue'),
    meta: {
      title: '高血脂产品推荐',
      keepAlive: true
    }
  },
  {
    name: 'nqyjkIndex',
    component: () => import('./view/nqyjk/index.vue'),
    meta: {
      title: '产品推荐',
      keepAlive: true
    }
  },
  {
    name: 'nqyjkjsIndex',
    component: () => import('./view/nqyjk/index2.vue'),
    meta: {
      title: '产品推荐',
      keepAlive: true
    }
  },
  {
    name: 'detail',
    component: () => import('./view/detail.vue'),
    meta: {
      title: '详情界面'
    }
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
  mode: 'hash',
  routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
